<template>
  <span></span>
</template>

<script setup>

window.maxPdfPages = 0;
window.pdfPageCounters = [];

</script>